const GLOBALS = require("./globals.js");


// soupmail object
$soupmail = {};
$soupmail.control = {};
$soupmail.images = GLOBALS.images;

// init constants
// Pin.setPublishableKey($config.pin_publishable_key);

// init variables
$controllers.dashboard.refreshTimer = '';
$controllers.all.preventHeaderClickHandler=false;
if (typeof($config.autoload) == 'undefined') {
	$config.autoload = true;
}
$config.this_path = $config.this_path.replace('/index.html', '').replace('/index.php', '').replace('/mobile.html', '').replace('/mobile.php', '').replace('/test.php', '');

// Start the app... this code runs once only, when the page has loaded
jQuery(document).ready(function() {
	
	// autoload the page if necessary (usually true)
	if ($config.autoload) {
		
		// init the html for all views
		$views.all.init();
		
		// startup the app
		$controllers.all.init();
		
	}
	
	// mobile devices: go to the top of the page, with the address bar not visible
	if ($config.mobile) {
		$views.all.scrollToTop();
	}
	
	// if the web browser supports onhashchange event (Chrome 5+, Safari 5+, FF3.6+, IE8+), then handle someone changes the hash tag url
	if ("onhashchange" in window) {
		window.onhashchange = function () {
			$controllers.all.loadNavigation(window.location.hash);
		}
	}
	
	// ensure we are running an up-to-date version of the UI
	setTimeout ('$controllers.all.checkVersion();', 5000);		// when page first loaded, check after 5 seconds
	setInterval('$controllers.all.refreshOnDeploy();', 60000);	// every minute do another check, in case we deploy while someone is using the UI
	
});

jQuery(document).keyup(function(e) {
	// if someone hits the ESCAPE key on their keyboard...
	if (e.keyCode == 27) {
//		jQuery('.dashboard-ultrasearch-results').hide();
		jQuery("#search-options, #soupmail-searchfilter-closearea").hide();
		$views.main.resizeLHScolumn();
		jQuery("body").removeClass("message-overlay");
	}
});

jQuery(window).resize(function() {
	// no action taken at present
});

$soupmail.testFailure = function($message) {
	if ($config.testMode) {
		ok(false, $message);
		if (QUnit.config.semaphore > 0) {
			start();
		}
	}
};


// WEBPACK FOOTER //
// ./src/js/soupmail.ui.base.js